import {
  PaymentReviewFailureErrorCode,
  PaymentReviewFailureReason,
} from "@/models/operations/paymentReviewRecord/paymentReviewRecord.types"

type FailureReasonsMapped = {
  [
    key in keyof typeof PaymentReviewFailureErrorCode
  ]: PaymentReviewFailureReason
}

export const FAILURE_REASONS_MAPPED: FailureReasonsMapped = {
  ACCOUNT_HAS_RECENT_TARIFF_CHANGE: {
    text: "Account has a recent tariff change",
    type: "danger",
  },
  ACCOUNT_EXCLUDED: {
    text: "Account is excluded from review",
    type: "warning",
  },
  ACCOUNT_UNDER_REVIEW: {
    text: "Account is under review",
    type: "warning",
  },
  PAYMENT_AMOUNT_CALCULATION: {
    text: "An error occurred calculating the payment amount",
    type: "danger",
  },
  ACCOUNT_BALANCE: {
    text: "An exception occurred attempting to retrieve account balance",
    type: "danger",
  },
  ACCOUNT_BALANCE_RESERVE_RATE: {
    text: "Cannot find an account balance reserve rate",
    type: "danger",
  },
  MISSING_PRODUCT_RATES: {
    text: "Cannot find any product rates",
    type: "danger",
  },
  MISSING_PRODUCT_RATE: {
    text: "Cannot find product rate for a product",
    type: "danger",
  },
  CLOSE_TO_PAYMENT_DATE: {
    text: "Close to payment date",
    type: "warning",
  },
  MISSING_METER_POINT_ESTIMATED_USAGE: {
    text: "Could not find an estimated usage for a meter point",
    type: "danger",
  },
  EMPTY_PRODUCTS: {
    text: "Could not find any products",
    type: "danger",
  },
  SUGGESTED_PAYMENT: {
    text: "Could not get a suggested payment amount",
    type: "danger",
  },
  ZERO_CURRENT_PAYMENT_AMOUNT: {
    text: "Current payment amount is zero",
    type: "warning",
  },
  LARGE_CHANGE_THRESHOLD: {
    text: "Increase is above the large change threshold",
    type: "warning",
  },
  SMALL_CHANGE_THRESHOLD: {
    text: "Increase is inside small change threshold",
    type: "warning",
  },
  PSP_HAS_RECENTLY_CHANGED: {
    text: "Payment schedule recently changed",
    type: "warning",
  },
  INVALID_DISCOUNT: {
    text: "Invalid discount",
    type: "danger",
  },
  INVALID_METER_POINT_ESTIMATED_USAGE: {
    text: "Invalid meter point estimated usage",
    type: "danger",
  },
  GENERAL_CALCULATION: {
    text: "General error occurred during calculation",
    type: "danger",
  },
  CREATE_PAYMENT_SCHEDULE: {
    text: "Junifer could not create a payment schedule",
    type: "danger",
  },
  STOP_PAYMENT_SCHEDULE: {
    text: "Junifer could not stop a payment schedule",
    type: "danger",
  },
  INVALID_PRODUCTS_SIZE: {
    text: "Junifer products returned an invalid size",
    type: "danger",
  },
  EMAIL_TEMPLATE_MISSING: {
    text: "Missing an email template",
    type: "danger",
  },
  MALFORMED_PAYMENT_REVIEW_RECORD: {
    text: "Missing crucial field to complete calculation",
    type: "danger",
  },
  MISSING_REQUIRED_FIELDS: {
    text: "Missing required fields",
    type: "danger",
  },
  INVALID_REQUIRED_CALCULATION_VALUES: {
    text: "Missing required values to produce a cost calculation item",
    type: "danger",
  },
  NEW_PAYMENT_AMOUNT_OUTSIDE_BOUNDS: {
    text: "New payment amount is outside acceptable bounds",
    type: "warning",
  },
  ZERO_NEW_PAYMENT_AMOUNT: {
    text: "New payment amount is zero",
    type: "warning",
  },
  EMPTY_METER_POINTS: {
    text: "No meter points found",
    type: "danger",
  },
  PAYMENT_REVIEW_NOT_FOUND: {
    text: "Payment review not found",
    type: "danger",
  },
  PAYMENT_REVIEW_RECORD_NOT_FOUND: {
    text: "Payment review record not found",
    type: "danger",
  },
  CREATE_JUNIFER_NOTE: {
    text: "Problem attempting to create Junifer note",
    type: "danger",
  },
  SEND_EMAIL_COMMUNICATION: {
    text: "Problem attempting to send an email communication",
    type: "danger",
  },
  INTERNAL_DATA_ALIGNMENT: {
    text: "Problem occurred aligning data from an external source",
    type: "danger",
  },
  PRODUCT_EXPIRING: {
    text: "Product is expiring soon",
    type: "warning",
  },
  ZERO_SUGGESTED_PAYMENT_AMOUNT: {
    text: "Suggested payment amount is zero",
    type: "warning",
  },
  UNKNOWN: {
    text: "Unknown error code",
    type: "danger",
  },
}
